"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SubLabel = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _labelModule = _interopRequireDefault(require("./label.module.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _fieldsize = _interopRequireWildcard(require("./fieldsize"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var SubLabel = function SubLabel(props) {
  var _cx;

  if (_react.default.Children.count(props.children) === 0) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)(props.className, (_cx = {}, (0, _defineProperty2.default)(_cx, _labelModule.default.SubLabelSmall, props.size === _fieldsize.default.SMALL), (0, _defineProperty2.default)(_cx, _labelModule.default.SubLabel, props.size === _fieldsize.default.DEFAULT), _cx)),
    "data-description": true
  }, props.children);
};

exports.SubLabel = SubLabel;
SubLabel.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  size: _propTypes.default.string
};
SubLabel.defaultProps = _objectSpread({}, _fieldsize.fieldSizeDefaultProps);

var Label = function Label(props) {
  var _cx2;

  if (_react.default.Children.count(props.children) === 0) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _labelModule.default.labelWrapper
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)(_labelModule.default.Label, (_cx2 = {}, (0, _defineProperty2.default)(_cx2, _labelModule.default.LabelSmall, props.size === _fieldsize.default.SMALL), (0, _defineProperty2.default)(_cx2, _labelModule.default.LabelDefault, props.size === _fieldsize.default.DEFAULT), _cx2), props.className),
    onClick: props.onClick,
    htmlFor: props.for
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _labelModule.default.labelContent
  }, props.children)), props.tooltip);
};

Label.propTypes = _objectSpread(_objectSpread({}, _fieldsize.fieldSizePropTypes), {}, {
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  for: _propTypes.default.string,
  children: _propTypes.default.node,
  tooltip: _propTypes.default.node
});
Label.defaultProps = _objectSpread({}, _fieldsize.fieldSizeDefaultProps);
var _default = Label;
exports.default = _default;